import { render, staticRenderFns } from "./textimage.vue?vue&type=template&id=d15396e4&"
import script from "./textimage.vue?vue&type=script&lang=js&"
export * from "./textimage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports